var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78377 6.78377L0.533768 13.0338C0.504733 13.0628 0.470265 13.0858 0.432329 13.1015C0.394394 13.1173 0.353735 13.1253 0.312674 13.1253C0.271613 13.1253 0.230954 13.1173 0.193019 13.1015C0.155084 13.0858 0.120615 13.0628 0.0915802 13.0338C0.0625457 13.0047 0.0395147 12.9703 0.0238013 12.9323C0.008088 12.8944 0 12.8537 0 12.8127C0 12.7716 0.008088 12.731 0.0238013 12.693C0.0395147 12.6551 0.0625457 12.6206 0.0915802 12.5916L6.12049 6.56267L0.0915802 0.533768C0.0329424 0.47513 0 0.3956 0 0.312674C0 0.229748 0.0329424 0.150218 0.0915802 0.0915799C0.150218 0.0329421 0.229748 0 0.312674 0C0.3956 0 0.47513 0.0329421 0.533768 0.0915799L6.78377 6.34158C6.81282 6.3706 6.83587 6.40507 6.8516 6.443C6.86733 6.48094 6.87542 6.52161 6.87542 6.56267C6.87542 6.60374 6.86733 6.64441 6.8516 6.68234C6.83587 6.72028 6.81282 6.75475 6.78377 6.78377Z",
    fill: "#4D5F6E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rightArrow.4989b10bb230ca12e7d4feb48cac7a75.svg";